import React from 'react';
import styles from './AdminPage.module.css';
import { Link } from 'react-router-dom';

export const AdminPage = () => {

	const setSchema = (schema) => {
		window.sessionStorage.setItem("schema", schema);
	}
	return (
		<div className={styles.main}>
			<Link to={'/admin/settings'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Настройки
				</div>
			</Link>
			<Link to={'/admin/items'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Игры
				</div>
			</Link>
			<Link to={'/admin/subs'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Подписки
				</div>
			</Link>
			<Link to={'/admin/devices'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Девайсы
				</div>
			</Link>
			<Link to={'/admin/orders'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Заказы
				</div>
			</Link>
			<Link to={'/admin/users'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Пользователи
				</div>
			</Link>
			<Link to={'/admin/promo'} onClick={() => setSchema('')}>
				<div className={styles.btn}>
					Промокоды
				</div>
			</Link>
			<div className={styles.block}>
				<Link to={'/admin/schemasItems'} onClick={() => setSchema('PS_keys')}>
					<div className={styles.btn}>
						Товары (PS_keys)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('PS_keys')}>
					<div className={styles.btn}>
						Заказы (PS_keys)
					</div>
				</Link>
			</div>
			<div className={styles.block}>
				<Link to={'/admin/schemasItems'} onClick={() => setSchema('Nind_keys')}>
					<div className={styles.btn}>
						Товары (Nind_keys)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('Nind_keys')}>
					<div className={styles.btn}>
						Заказы (Nind_keys)
					</div>
				</Link>
			</div>
			<Link to={'/admin/schemasItems'} onClick={() => setSchema('services')}>
				<div className={styles.btn}>
					Товары (services)
				</div>
			</Link>
			<Link to={'/admin/orders'} onClick={() => setSchema('services')}>
				<div className={styles.btn}>
					Заказы (services)
				</div>
			</Link>
			<div className={styles.block}>
				<Link to={'/admin/xbox'} onClick={() => setSchema('xbox')}>
					<div className={styles.btn}>
						Товары (xbox)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('xbox')}>
					<div className={styles.btn}>
						Заказы (xbox)
					</div>
				</Link>
			</div>

			<div className={styles.block}>
				<Link to={'/admin/schemasItems'} onClick={() => setSchema('valorant_keys')}>
					<div className={styles.btn}>
						Товары (valorant_keys)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('valorant_keys')}>
					<div className={styles.btn}>
						Заказы (valorant_keys)
					</div>
				</Link>
			</div>

			<div className={styles.block}>
				<Link to={'/admin/schemasItems'} onClick={() => setSchema('steam')}>
					<div className={styles.btn}>
						Товары (Steam)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('steam')}>
					<div className={styles.btn}>
						Заказы (Steam)
					</div>
				</Link>
				<Link to={'/admin/adding-orders'} onClick={() => setSchema('steam')}>
					<div className={styles.btn}>
						Пополнения (Steam)
					</div>
				</Link>
			</div>

			<div className={styles.block}>
				<Link to={'/admin/sharing-items'} onClick={() => setSchema('PS_sharing')}>
					<div className={styles.btn}>
						Товары (PS_sharing)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('PS_sharing')}>
					<div className={styles.btn}>
						Заказы (PS_sharing)
					</div>
				</Link>
			</div>

			<div className={styles.block}>
				<Link to={'/admin/schemasItems'} onClick={() => setSchema('fifa')}>
					<div className={styles.btn}>
						Товары (FIFA)
					</div>
				</Link>
				<Link to={'/admin/orders'} onClick={() => setSchema('fifa')}>
					<div className={styles.btn}>
						Заказы (FIFA)
					</div>
				</Link>
			</div>
		</div>
	);
};
